import React from "react";
import { Modal } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import { Button, Form, TextArea } from "components/form";
import { useTranslation } from "react-i18next";
import Rating from "pages/details/components/rating";
import { client } from "helpers/client";
import { toast } from "react-toastify";
import { errorClass } from "components/classes";
import { Review } from "pages/details/components/review-card";
import {useQueryClient} from "react-query";
import {useAuthContext} from "store/auth";

interface Props {
  onHide: () => void;
  show: boolean;
  appId: number;
  review?: Review;
}

const ReviewDialog = ({ review, appId, onHide, show = false }: Props) => {
  const {t} = useTranslation('details')
  const queryClient = useQueryClient()
  const [{user}]  = useAuthContext();
  const customerId = user.Id;

  function success(message: string) {
    toast.success(t(message));
    queryClient.invalidateQueries("my-review");
    queryClient.invalidateQueries(["app-details", appId]);
    onHide();
  }

  function handleSubmit(d: any) {
    if (review)
      return client("/customerReview/update", { data: { id: review.id, ...d } }).then(
        ({ response }) => {
          if (response) success("common:form.updated");
        }
      );
    client("/customerReview/create", {
      data: {
        ...d,
        applicationId: appId,
        customerId,
      },
    }).then(({ response }) => {
      if (response) success("common:form.added");
    });
  }

  return (
    <div>
      <Modal
        size="lg"
        centered
        show={show}
        onHide={onHide}
        className="all-modal changeNumber"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>{t("appDetails.writeReview")}</h1>
          </div>
          <Form
            onSubmit={handleSubmit}
            defaultValues={{
              rate: review?.rate ?? "",
              review: review?.review ?? "",
            }}
          >
            {({ setValue, watch, register, formState: { errors } }) => {
              return (
                <>
                  <TextArea
                    rules={{ required: "errors:required" }}
                    label={t(
                      "appDetails.Tell others what you think about this app. Would you recommend it, and why?"
                    )}
                    id="review"
                  />
                  <div className="d-flex flex-column align-items-center">
                  <Rating
                    size="large"
                    {...register("rate", { required: "errors:reviewRating" })}
                    rating={watch("rate")}
                    onChange={(rate) =>
                      setValue("rate", rate, { shouldValidate: true })
                    }
                  />
                    {/* @ts-ignore */}
                  <span className={errorClass}>{t(errors.rate?.message)}</span>
                  </div>
                  <Button className="btn-blue">{t("appDetails.submitReview")}</Button>
                </>
              );
            }}
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ReviewDialog;
